import axios from "~/plugins/axios";

export default {
  find(customerId, includes = null) {
    return axios.get(`/web_api/v1/customer/${customerId}`, {
      params: {
        include: includes,
      },
    })
      .then((response) => response.data);
  },
  paginate(page = 1) {
    return axios.get("/web_api/v1/customer", {
      params: {
        page,
      },
    })
      .then((response) => response.data);
  },
  findByIds(ids) {
    return axios.post("F/web_api/v1/customer/by_ids", { customer_ids: ids }).then((response) => response.data);
  },
  search(query, includes = null) {
    return axios.get("/web_api/v1/customer/search", {
      params: {
        query,
        includes,
      },
    })
      .then((response) => response.data);
  },
  searchByName(lastName, initials, limit, includes = []) {
    return axios.post("/web_api/v1/customer/by_name", {
      last_name: lastName,
      initials,
      limit,
      include: includes,
    })
      .then((response) => response.data);
  },
  detailedSearch(query, secondQuery, type, limit, includes = []) {
    return axios.post("/web_api/v1/customer/detailed_search", {
      query,
      second_query: secondQuery,
      type,
      limit,
    }, { params: { include: includes } })
      .then((response) => response.data);
  },
  findFamily(customerId, includes = []) {
    return axios.get(`/web_api/v1/customer/${customerId}/family`, {
      params: {
        include: ["main", "partner", "children", ...includes],
      },
    })
      .then((response) => response.data);
  },
  findPartnerByCustomerId(customerId, includes = []) {
    return axios.get(`/web_api/v1/customer/partner_by_customer/${customerId}`, {
      params: {
        include: includes,
      },
    })
      .then((response) => response.data);
  },
  getByStaticSearchHash(staticSearchId) {
    return axios.get(`/web_api/v1/customer/by_static_search/${staticSearchId}`)
      .then((response) => response.data);
  },
  findByRelationNumberAndType(relationNumber, type) {
    return axios.post(`/web_api/v1/customer/by_relation_number_and_type/${relationNumber}`, {
      number: relationNumber,
      relation_number_type_id: type,
    })
      .then((response) => response.data);
  },
};
